import ContractDetailServices from '@/views/ContractDetail/ContractDetailServices';

import {
  SET_CONTRACT_DETAIL,
  SET_CLIENT_DETAIL,
  SET_SUMMARY,
  SET_REPAYMENT_SCHEDULE,
  SET_TRANSACTIONS,
  SET_CONTRACT_DOCS,
  SET_CONTRACT_DOC_TYPES,
  SET_ASSET,
  SET_CONTRACT_NOTES,
} from './types';

const addContractNote = async (contractId, msg) => {
  await ContractDetailServices.addContractNotes(contractId, msg);
};

export default {
  async getContractDetail({ commit }, id) {
    const contract = await ContractDetailServices.getContractDetail(id);
    commit(SET_CONTRACT_DETAIL, contract);
  },

  async rejectContract({ commit, state }, { id, data }) {
    const contract = await ContractDetailServices.rejectContract(id, data);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Hủy hợp đồng');
    this.getContractNotes();
  },

  async approveContract({ commit, state }, id) {
    const contract = await ContractDetailServices.approveContract(id);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Duyệt hợp đồng');
    this.getContractNotes();
  },

  async undoContractApproval({ commit, state }, id) {
    const contract = await ContractDetailServices.undoContractApproval(id);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Bỏ duyệt hợp đồng');
    this.getContractNotes();
  },

  async disburseContract({ commit, state }, { id, data }) {
    const contract = await ContractDetailServices.disburseContract(id, data);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Giải ngân hợp đồng');
    this.getContractNotes();
  },

  async undoContractDisbursal({ commit, state }, id) {
    const contract = await ContractDetailServices.undoContractDisbursal(id);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Hủy giải ngân hợp đồng');
    this.getContractNotes();
  },

  async undoContractRepayment({ commit, state }, id) {
    const contract = await ContractDetailServices.undoContractRepayment(id);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Hủy tất toán hợp đồng');
    this.getContractNotes();
  },

  async undoContractRenewal({ commit, state }, id) {
    const renewalId = state.targetingContract.renewal.id;
    const contract = await ContractDetailServices.undoContractRenewal(id);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(state.targetingContract.id, 'Hủy gia hạn hợp đồng');
    await addContractNote(renewalId, `Hủy gia hạn hợp đồng #${id}`);
    this.getContractNotes();
  },

  async undoParentContractRenewal({ commit, state }, id) {
    const parent = await ContractDetailServices.undoParentContractRenewal(id);
    const contract = await ContractDetailServices.getContractDetail(state.targetingContract.publicId);
    commit(SET_CONTRACT_DETAIL, contract);

    await addContractNote(parent.id, 'Hủy gia hạn hợp đồng');
    await addContractNote(state.targetingContract.id, `Hủy gia hạn hợp đồng #${parent.publicId}`);
    this.getContractNotes();
  },

  async getClientDetailByContractId({ commit }, id) {
    const result = await ContractDetailServices.getClientDetailByContractId(id);
    commit(SET_CLIENT_DETAIL, result);
  },

  async getContractSummaryByMifosId({ commit }, id) {
    try {
      const result = await ContractDetailServices.getContractSummaryByMifosId(id);
      commit(SET_SUMMARY, result);
    } catch (error) {
      commit(SET_SUMMARY, null);
    }
  },

  async getRepaymentScheduleByMifosId({ commit }, id) {
    const result = await ContractDetailServices.getRepaymentScheduleByMifosId(id);
    commit(SET_REPAYMENT_SCHEDULE, result);
  },

  async getTransactionsByMifosId({ commit }, id) {
    const result = await ContractDetailServices.getTransactionsByMifosId(id);
    commit(SET_TRANSACTIONS, result);
  },

  async getContractDocTypes({ commit }) {
    const result = await ContractDetailServices.getContractDocTypes();
    commit(SET_CONTRACT_DOC_TYPES, result);
  },

  async getAsset({ commit, state }) {
    const result = await ContractDetailServices.getAsset(state.targetingContract.assetId);
    commit(SET_ASSET, result);
  },

  async getContractNotes({ commit, state }) {
    const result = await ContractDetailServices.getContractNotes(state.targetingContract.id);
    commit(SET_CONTRACT_NOTES, result);
  },

  async getContractDocs({ commit, state }) {
    const result = await ContractDetailServices.getContractDocs(state.targetingContract.id);
    commit(SET_CONTRACT_DOCS, result);
  },
};
